import React, { useState, useRef, useEffect } from "react";
import "./AddTodoList.scss";
import "../../../../components/ModalContent/ModalComponents.scss";
import { colorOptions, normalizeColor } from "../../../../utils/colors";
import ColorPicker from "../../../../components/ColorPicker/ColorPicker";

function AddTodoList({ createTodoList, cancelCreateTodoList }) {
  const [title, setTitle] = useState("");
  const [selectedColor, setSelectedColor] = useState(colorOptions[0]);
  const [showTitleError, setShowTitleError] = useState(false);
  const [listType, setListType] = useState("todo"); // "todo" or "checklist"

  const handleCreateTodoList = () => {
    if (title.trim()) {
      const colorHex = normalizeColor(selectedColor);
      createTodoList(title.trim(), colorHex, listType);
      setTitle("");
      setSelectedColor(colorOptions[0]);
      setListType("todo");
      setShowTitleError(false);
    } else {
      setShowTitleError(true);
    }
  };

  const inputRef = useRef(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="add-todolist-content">
      <div className="modal-title">
        <div>Add List</div>
      </div>
      <div className="modal-form">
        <div className="modal-form-title">Title</div>
        <input
          ref={inputRef}
          type="text"
          className="modal-text-input"
          placeholder="List Title (e.g., Work, Shopping)"
          value={title}
          onChange={(e) => {
            setTitle(e.target.value);
            if (showTitleError && e.target.value.trim()) {
              setShowTitleError(false);
            }
          }}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              handleCreateTodoList();
            }
          }}
        />
        {showTitleError && (
          <div className="modal-helper-text">Please enter a title</div>
        )}

        <div className="modal-form-title">Type</div>
        <div className="modal-checkbox-group">
          <label className="modal-checkbox-label">
            <input
              type="checkbox"
              checked={listType === "todo"}
              onChange={() => setListType("todo")}
            />
            <span>Todo List</span>
          </label>
          <label className="modal-checkbox-label">
            <input
              type="checkbox"
              checked={listType === "checklist"}
              onChange={() => setListType("checklist")}
            />
            <span>Checklist</span>
          </label>
        </div>

        <div className="modal-form-title">Color</div>
        <div className="color-picker-wrapper">
          <ColorPicker
            selectedColor={selectedColor}
            onColorSelect={setSelectedColor}
          />
        </div>

        <div className="modal-form-buttons">
          <button
            className="modal-button cancel"
            onClick={() => {
              setTitle("");
              setSelectedColor(colorOptions[0]);
              setListType("todo");
              setShowTitleError(false);
              cancelCreateTodoList();
            }}
          >
            Cancel
          </button>
          <button className="modal-button save" onClick={handleCreateTodoList}>
            Create
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddTodoList;
